<template>
    <div id="invoice-page">
        <vx-card id="invoice-container">
            <!-- INVOICE CONTENT -->
            <div>
              <div class="vx-row">
                <div class="vx-col w-full mb-base">
                  <vs-alert active="true" color="danger" icon-pack="feather" icon="icon-info" style="height:100%" v-if="!dataIntervention.quote.id">
                    <span>Ce <b>devis</b> n'est pas encore créée</span>
                  </vs-alert>
                </div>
              </div>
              <form data-vv-scope="data">
                <div class="vx-row">
                    <div class="vx-col w-full sm:w-2/3 lg:w-2/3 mb-base">
                        <table>
                            <tr>
                              <td class="font-semibold">Nom & prénom</td>
                              <td class="pl-5">{{ dataIntervention.client.firstname+' '+dataIntervention.client.lastname }}</td>
                            </tr>
                            <tr>
                              <td class="font-semibold">Compagne</td>
                              <td class="pl-5">{{ dataIntervention.client.company }}</td>
                            </tr>
                            <tr>
                              <td class="font-semibold">Siret</td>
                              <td class="pl-5">{{ dataIntervention.client.siret }}</td>
                            </tr>
                            <tr>
                              <td class="font-semibold">Email</td>
                              <td class="pl-5">{{ dataIntervention.client.email }}</td>
                            </tr>
                            <tr>
                              <td class="font-semibold">Adresse</td>
                              <td class="pl-5">{{ dataIntervention.client.address + ' '+ dataIntervention.client.zipcode +' '+ dataIntervention.client.city }}</td>
                            </tr>
                        </table>
                    </div>
                    <div class="vx-col w-full sm:w-2/3 lg:w-1/3 mb-base">
                      <table class="w-full ">
                        <tr>
                          <td class="font-semibold">Numéro : </td>
                          <td><vs-input disabled="true" v-model="dataIntervention.quote.num_quote" class="w-full"/></td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Date création : </td>
                          <td>
                            <flat-pickr disabled="true" :config="configdateTimePicker" v-model="dataIntervention.quote.date" name="date" class="w-full"  v-validate="'required'" />
                            <span class="text-danger text-sm" v-show="errors.has('data.date')">{{ errors.first('data.date') }}</span>
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Mode de règlement : </td>
                          <td >
                            <v-select disabled="true" class="w-full" :clearable="false" label="label" v-model="dataIntervention.quote.payment_type" :options="payment_type_choices" :reduce="payment_type => payment_type.value" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                              <div slot="no-options">Désolé, aucune etat correspondante.</div>
                            </v-select>
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Date limite de règlement : </td>
                          <td>
                            <flat-pickr disabled="true" :config="configdateTimePicker" v-model="dataIntervention.quote.date_echeance" class="w-full" />
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Etat : </td>
                          <td >
                            <v-select disabled="true" class="w-full" :clearable="false" label="label" v-model="dataIntervention.quote.status" :options="status_choices" :reduce="status => status.value" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                              <div slot="no-options">Désolé, aucune etat correspondante.</div>
                            </v-select>
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">TVA : </td>
                          <td >
                            <v-select disabled="true"  class="w-full" :clearable="false" label="label" v-model="dataIntervention.quote.tva_value" :options="Tva_choices" :reduce="tva => tva.value" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                              <div slot="no-options">Désolé, aucune tva correspondante.</div>
                            </v-select>
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Réduction : </td>
                          <td>
                            <vs-switch disabled="true" color="success" v-model="dataIntervention.quote.reduction">
                              <span slot="on">Oui</span>
                              <span slot="off">Non</span>
                            </vs-switch>
                          </td>
                        </tr>
                      </table>
                    </div>
                </div>

                 <div class="vx-row">
                    <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
                      <vs-input disabled="true" label="Objet" size="large" class="inputx" placeholder="" v-model="dataIntervention.quote.object" style="width: 100%"/>
                    </div>
                 </div>
              </form>

              <form data-vv-scope="lines">
                <vs-table hoverFlat :data="dataIntervention.quote.lines">
                    <!-- HEADER -->
                    <template slot="thead">
                        <vs-th style="width: 50%">Désignation</vs-th>
                        <vs-th style="width: 10%" v-if="dataIntervention.quote.reduction">Réduction %</vs-th>
                        <vs-th style="width: 10%">PU HT</vs-th>
                        <vs-th style="width: 6%;">Qté</vs-th>
                        <vs-th style="width: 12%">Total HT</vs-th>
                        <vs-th style="width: 12%">TTC</vs-th>
                    </template>

                    <!-- DATA -->
                    <template slot-scope="{data}">
                        <vs-tr v-for="(tr, index) in data" :key="index">
                            <vs-td>
                              <ejs-autocomplete disabled="disabled" :dataSource="products" :fields="{value: 'title'}" v-model="tr.item" @select="selectItem($event,index)" noRecordsTemplate=''></ejs-autocomplete>
                              <vs-textarea disabled="true" label="description" rows="2" v-model="tr.description"/>
                            </vs-td>
                            <vs-td v-if="dataIntervention.quote.reduction"><vs-input class="inputx" v-model="tr.redc" style="width: 100%"/></vs-td>
                            <vs-td><vs-input disabled="true"  class="inputx" v-model="tr.cost" @input="commaFilter($event, index)" style="width: 100%"/></vs-td>
                            <vs-td><vs-input-number disabled="true" v-model="tr.qty" icon-inc="expand_less" min="1" icon-dec="expand_more"/></vs-td>
                            <vs-td><vs-input disabled="true" :ref="'tht-'+index" class="inputx" :value="Math.round(((tr.cost * tr.qty) + Number.EPSILON) * 100) / 100" style="width: 100%" @change="calculPU($event, index)"/></vs-td>
                            <vs-td><vs-input disabled="true" :ref="'ttc-'+index" class="inputx" :value="Math.round(((tr.cost * tr.qty * (dataIntervention.quote.tva_value / 100 + 1)) + Number.EPSILON) * 100) / 100" style="width: 100%" @change="calculPUFromTTC($event, index)"/></vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
              </form>

              <vs-table hoverFlat class="w-1/2 ml-auto mt-4" noDataText="">
                  <vs-tr>
                      <vs-th>Total HT</vs-th>
                      <vs-td>{{ ht }}</vs-td>
                  </vs-tr>
                  <vs-tr>
                      <vs-th>Montant TVA ({{ dataIntervention.quote.tva_value }}%)</vs-th>
                      <vs-td>{{ tva }}</vs-td>
                  </vs-tr>
                  <vs-tr v-if="dataIntervention.quote.reduction">
                    <vs-th>Réduction</vs-th>
                    <vs-td>{{ reduction }}</vs-td>
                  </vs-tr>
                  <vs-tr>
                      <vs-th>Total TTC</vs-th>
                      <vs-td>{{ ttc }}</vs-td>
                  </vs-tr>
              </vs-table>
            </div>
        </vx-card>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { French } from 'flatpickr/dist/l10n/fr.js'
import { mapActions, mapGetters } from 'vuex'
import vSelect from 'vue-select'

import { Validator } from 'vee-validate';
import { AutoCompletePlugin } from '@syncfusion/ej2-vue-dropdowns';


const dict = {
  custom: {
    date: {
      required: 'La date de creation est obligatoire'
    }
  }
};

// register custom messages
Validator.localize('fr', dict);

export default{
    components: {
      flatPickr,vSelect,AutoCompletePlugin
    },
    props: ['dataIntervention'],
    data() {
        return {
          reductionGlobal : null,
          configdateTimePicker: {
            locale: French,
            enableTime: false,
            dateFormat: 'Y-m-d'
          },
          payment_type_choices : [
            {value: 'card', label: 'Carte bancaire'},
            {value: 'transfer', label: 'Virement bancaire'},
            {value: 'cash', label: 'Espèces'},
            {value: 'cheque', label: 'Chèque'},
            {value: 'paypal', label: 'Paypal'},
          ],
          status_choices : [
            {value: 'issued', label: 'Créé'},
            {value: 'sent', label: 'Envoyé'},
            {value: 'rejected', label: 'Rejeté'},
            {value: 'accepted', label: 'Accepté'}
          ],
          Tva_choices : [
            {value: 10, label: '10 %'},
            {value: 15, label: '15 %'},
            {value: 20, label: '20 %'},
          ],
        }
    },
    computed: {
      ...mapGetters('products', {'products' : 'GET_ITEMS'}),

      client() {
        return this.dataIntervention ? this.dataIntervention.quote.client : {firstname: null,lastname: null,company:null,address:null,zipcode:null,city:null}
      },
      items() {
        return this.dataIntervention ? this.dataIntervention.quote.lines : [{id: null,item: null,description: null,cost: 0,qty: 1,redc: 0}]
      },
      ht() {
        let num = this.items.reduce((sum, i) =>sum + (i.cost*i.qty), 0)
        return Math.round((num + Number.EPSILON) * 100) / 100
      },
      tva() {
        let num = (this.ht - this.reduction)  * this.dataIntervention.quote.tva_value / 100
        return Math.round((num + Number.EPSILON) * 100) / 100
      },
      reduction() {
        let num = this.dataIntervention.quote.reduction ? this.items.reduce((sum, i) =>sum + ((i.cost*i.qty) * i.redc / 100), 0) : 0
        return Math.round((num + Number.EPSILON) * 100) / 100
      },
      ttc() {
        let num =  (this.ht + this.tva) - this.reduction
        return Math.round((num + Number.EPSILON) * 100) / 100
      },
      notCreated() {
        return !!!this.dataIntervention.quote.id
      }
    },
    methods: {
      ...mapActions('quotes', {'getQuote':'getItem','addQuote':'addItem','updateQuote':'updateItem'}),
      ...mapActions('products', {'fetchProducts' : 'fetchItems'}),

      addItem() {
          if(this.has_empty_line()) {
            this.items.push({ id: null,item: null,description: null,cost: 0,qty: 1,redc: 0})
          }

      },

      removeItem(index) {
        this.items.splice(index, 1)
      },

      successMsg(title,msg){
        this.$vs.notify({
          title: title,
          text: msg,
          color:'success',
          iconPack: 'feather',
          icon:'icon-check',
          position:'top-right'
        })
      },

      errorMsg(title,msg){
        this.$vs.notify({
          title: title,
          text: msg,
          color:'danger',
          iconPack: 'feather',
          icon:'icon-check',
          position:'top-right'
        })
      },

      has_one_empty_line() {
        return !!(this.dataIntervention.quote.lines.length == 1) && !this.dataIntervention.quote.lines.slice(-1)[0].item
      },

      has_empty_line() {
        return !!this.dataIntervention.quote.lines.slice(-1)[0].item
      },

      saveData() {

         this.$validator.validateAll('data').then(result => {
          if (result) {
            if(!this.has_one_empty_line()){

              this.dataIntervention.quote.ht = this.ht
              this.dataIntervention.quote.ttc = this.ttc
              this.dataIntervention.quote.tva = this.tva

              if(this.dataIntervention.quote.id) {
                this.$emit('showLoading')
                this.updateQuote(this.dataIntervention).then(result => {
                  this.dataIntervention.quote = result.data.quote
                  if(!this.dataIntervention.invoice.id) this.dataIntervention.invoice.lines = result.data.quote.lines
                  this.$emit('closeLoading')
                  this.successMsg("Modification","Le devis est bien modifié");
                }).catch(() => {
                  this.$emit('closeLoading')
                  this.errorMsg('Modification','Trouvé un error lor de l modification')
                })

              }else{
                this.$emit('showLoading')
                this.addQuote(this.dataIntervention).then(result => {
                  this.dataIntervention.quote = result.data.quote
                  if(!this.dataIntervention.invoice.id) this.dataIntervention.invoice.lines = result.data.quote.lines
                  this.$emit('closeLoading')
                  this.successMsg("L'ajout","Le devis est bien ajouté");
                }).catch(() => {
                  this.$emit('closeLoading')
                  this.errorMsg('L\'Ajout','Trouvé un error lor de l\'insertion')
                })
              }


            }else{
              this.errorMsg('Erreur','Pour enregistrer ce devis besoin au moin un produit')
            }
            return true
          }else {
            return false
          }
        })
      },

      openPdf() {
        window.open(`https://hellodepann.vosfactures.fr/invoices/${this.dataIntervention.quote.api_id}?format=pdf&inline=yes&?api_token=8hpAUs73rV4vbcDRoDo`, '_blank');
      },

      openSignPdf() {
        window.open(`https://hellodepann.vosfactures.fr/invoices/${this.dataIntervention.quote.api_id}?format=pdf&inline=yes&?api_token=8hpAUs73rV4vbcDRoDo&invoice_template_id=8397`, '_blank');
      },

      downloadPdf() {
          let a = document.createElement("a");
          a.setAttribute("href", `https://hellodepann.vosfactures.fr/invoices/${this.dataIntervention.quote.api_id}.pdf?api_token=8hpAUs73rV4vbcDRoDo`);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
      },
      selectItem(data,index) {
        this.dataIntervention.quote.lines[index].cost = data.itemData.price
      },
      calculPU(event, index) {
        const ttcInput = `tht-${index}`
        var ht = parseFloat(event.target.value.replace(/,/g, '.'))
        this.$refs[ttcInput][0].value = ht
        this.dataIntervention.quote.lines[index].cost = ht > 0 ? Math.round(((ht / this.dataIntervention.quote.lines[index].qty) + Number.EPSILON) * 100) / 100 : 0
      },
      calculPUFromTTC(event, index) {
        const ttcInput = `ttc-${index}`
        var ttc = parseFloat(event.target.value.replace(/,/g, '.'))
        this.$refs[ttcInput][0].value = ttc
        this.dataIntervention.quote.lines[index].cost = ttc > 0 ?  Math.round(((ttc / this.dataIntervention.quote.lines[index].qty / (this.dataIntervention.quote.tva_value / 100 + 1)) + Number.EPSILON) * 100) / 100 : 0
      },
      commaFilter($event, index) {
        this.dataIntervention.quote.lines[index].cost = this.dataIntervention.quote.lines[index].cost.replace(/,/g, '.')
      }
    },

    mounted() {
      this.showLoading = true
      this.getQuote(this.id).then(result => {
        this.quote = result.data
      })
      this.showLoading = false
    },
    created () {
      this.fetchProducts()
    }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/extraComponents/autocomplete.scss";
@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}
</style>

<style>
@import "../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css";

input.e-input::selection {
  background: #001f53  !important;
}

[dir] .e-input-group:not(.e-float-icon-left):not(.e-float-input)::before, [dir] .e-input-group:not(.e-float-icon-left):not(.e-float-input)::after, [dir] .e-input-group.e-float-icon-left:not(.e-float-input) .e-input-in-wrap::before, [dir] .e-input-group.e-float-icon-left:not(.e-float-input) .e-input-in-wrap::after, [dir] .e-input-group.e-control-wrapper:not(.e-float-icon-left):not(.e-float-input)::before, [dir] .e-input-group.e-control-wrapper:not(.e-float-icon-left):not(.e-float-input)::after, [dir] .e-input-group.e-control-wrapper.e-float-icon-left:not(.e-float-input) .e-input-in-wrap::before, [dir] .e-input-group.e-control-wrapper.e-float-icon-left:not(.e-float-input) .e-input-in-wrap::after {
    background: #001f53  !important;
}

</style>
